import React from "react";
import {Form} from 'react-bootstrap';
import STCFormControlFeedback from "./STCForm.Control.Feedback/STCForm.Control,Feedback";

function STCFormControl(props){

    return(
        <Form.Control
            style={props.style}
            className={props.className}
            name={props.name}

            ref={props.ref}
            as={props.as}
            disabled={props.disabled}
            htmlSize={props.htmlSize}
            id={props.id}
            isInvalid={props.isInvalid}
            isValid={props.isValid}
            onChange={props.onChange}
            plaintext={props.plaintext}
            readOnly={props.readOnly}
            size={props.size}
            type={props.type}
            value={props.value}
            defaultValue={props.defaultValue}
            bsPrefix={props.bsPrefix}
            placeholder={props.placeholder}
            autoComplete={props.autoComplete}
            required={props.required}
            multiple={props.multiple}
            sm={props.sm}
            rows={props.rows}
            step={props.step}
            max={props.max}
            min={props.min}
            maxLength={props.maxLength}
            minLength={props.minLength}
        >
            {props.children}
        </Form.Control>
    )

}

STCFormControl.Feedback = STCFormControlFeedback;
export default STCFormControl;